module.exports = __webpack_public_path__ + "static/media/morse-code1.8ac2db6a.aac";